(function () {
  'use strict';

  if (window.FloramePrivacy) return;

  var analyticsCallbacks = new Set();
  var analyticsWasAllowed = false;
  var apiChecks = 0;
  var apiTimer = null;
  var featureLoadRequested = false;

  function customerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy
      ? window.Shopify.customerPrivacy
      : null;
  }

  function analyticsAllowed() {
    try {
      var api = customerPrivacy();
      return !!(api && typeof api.analyticsProcessingAllowed === 'function'
        && api.analyticsProcessingAllowed() === true);
    } catch (_) {
      return false;
    }
  }

  function preferencesAllowed() {
    try {
      var api = customerPrivacy();
      return !!(api && typeof api.preferencesProcessingAllowed === 'function'
        && api.preferencesProcessingAllowed() === true);
    } catch (_) {
      return false;
    }
  }

  function marketingAllowed() {
    try {
      var api = customerPrivacy();
      return !!(api && typeof api.marketingAllowed === 'function'
        && api.marketingAllowed() === true);
    } catch (_) {
      return false;
    }
  }

  function flushAnalyticsCallbacks() {
    if (!analyticsAllowed()) return false;
    if (analyticsWasAllowed) return true;
    analyticsWasAllowed = true;
    analyticsCallbacks.forEach(function (callback) {
      try { callback(); } catch (_) { }
    });
    analyticsCallbacks.clear();
    return true;
  }

  function requestPrivacyApi() {
    if (customerPrivacy() || featureLoadRequested) return;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        featureLoadRequested = true;
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () { retryConsentSync(); }
        );
      }
    } catch (_) {
      featureLoadRequested = false;
    }
  }

  function waitForPrivacyApi() {
    requestPrivacyApi();
    if (flushAnalyticsCallbacks() || apiChecks >= 40) {
      if (apiTimer) window.clearInterval(apiTimer);
      apiTimer = null;
      return;
    }
    apiChecks += 1;
  }

  function retryConsentSync() {
    apiChecks = 0;
    if (!apiTimer) apiTimer = window.setInterval(waitForPrivacyApi, 250);
    waitForPrivacyApi();
  }

  function onAnalyticsAllowed(callback) {
    if (typeof callback !== 'function') return function () { };
    if (analyticsAllowed()) {
      analyticsWasAllowed = true;
      callback();
      return function () { };
    }
    analyticsCallbacks.add(callback);
    if (!apiTimer) apiTimer = window.setInterval(waitForPrivacyApi, 250);
    return function () { analyticsCallbacks.delete(callback); };
  }

  function openPreferences(event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    try {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return true;
      }
    } catch (_) { }
    try {
      var api = customerPrivacy();
      if (api && typeof api.showPreferences === 'function') {
        api.showPreferences();
        return true;
      }
    } catch (_) { }
    var trigger = document.querySelector(
      '#shopify-pc__banner__btn-manage-prefs, [data-shopify-customer-privacy="preferences"], .shopify-pc__prefs__button'
    );
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  }

  document.addEventListener('visitorConsentCollected', function () {
    analyticsWasAllowed = false;
    retryConsentSync();
  });
  document.addEventListener('trackingConsentAccepted', retryConsentSync);

  window.FloramePrivacy = Object.freeze({
    analyticsAllowed: analyticsAllowed,
    preferencesAllowed: preferencesAllowed,
    marketingAllowed: marketingAllowed,
    onAnalyticsAllowed: onAnalyticsAllowed,
    openPreferences: openPreferences
  });
})();
